// src/components/LoadingSpinner.js

import React from 'react';

const LoadingSpinner = ({ 
  size = 'medium', 
  color = '#2196f3', 
  message = '', 
  centered = true 
}) => {
  const sizeMap = {
    small: '20px',
    medium: '40px',
    large: '60px'
  };

  const spinnerSize = sizeMap[size] || sizeMap.medium;

  const styles = {
    container: {
      display: centered ? 'flex' : 'inline-flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: centered ? 'center' : 'flex-start',
      gap: '12px',
      ...(centered && { 
        minHeight: '200px',
        width: '100%' 
      })
    },
    
    spinner: {
      width: spinnerSize,
      height: spinnerSize,
      border: `3px solid ${color}20`,
      borderTop: `3px solid ${color}`,
      borderRadius: '50%',
      animation: 'spin 1s linear infinite',
    },
    
    message: {
      fontSize: '14px',
      color: '#666',
      textAlign: 'center',
      maxWidth: '300px',
    }
  };

  // CSS アニメーションの追加
  React.useEffect(() => {
    const existingStyle = document.getElementById('spinner-styles');
    if (!existingStyle) {
      const style = document.createElement('style');
      style.id = 'spinner-styles';
      style.textContent = `
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `;
      document.head.appendChild(style);
    }
  }, []);

  return (
    <div style={styles.container}>
      <div style={styles.spinner}></div>
      {message && <div style={styles.message}>{message}</div>}
    </div>
  );
};

export default LoadingSpinner;